// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterFragmentFragment } from './cash-register.fragment.generated';
export type DataGroupedByOwnerCorporateDataFragmentFragment = { __typename?: 'DataGroupedByOwnerCorporateDataDTO', cashRegisterFiscalClosureAllowed: boolean, ownerCorporateDataId: number, cashRegisters: Array<{ __typename?: 'CashRegisterDTO', id: number, invoiceBlocks: Array<string>, ownerCorporateDataId: number, description: string, address: string, port: string | null, localAddress: string | null, username: string | null, doubleCopy: boolean, cashRegisterType: { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null } }> };

export const DataGroupedByOwnerCorporateDataFragmentFragment = gql`
    fragment DataGroupedByOwnerCorporateDataFragment on DataGroupedByOwnerCorporateDataDTO {
  cashRegisterFiscalClosureAllowed
  cashRegisters {
    ...CashRegisterFragment
  }
  ownerCorporateDataId
}
    ${CashRegisterFragmentFragment}`;
/* eslint-enable */